// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardCustomGiveBody = {
  poolId: string;
  awardTypeId: string;
  targetUserId: string;
};

export type typeAwardCustomGiveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { awardGrantId: string };
};

export type typeAwardCustomGiveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomGiveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomGiveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardCustomGiveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    awardTypeId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "awardTypeId", "targetUserId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardCustomGive(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardCustomGiveBody);
  }

  return async function postAwardCustomGive(
    payload: typeAwardCustomGiveBody,
  ): Promise<typeAwardCustomGiveOutput200 | typeAwardCustomGiveOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardCustomGive" failed before calling the network. #537bcce58d00`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#537bcce58d00" },
        },
        data: null,
      } as typeAwardCustomGiveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/custom-give`,
      httpMethod: "POST",
      options,
    })) as typeAwardCustomGiveOutput200 | typeAwardCustomGiveOutput400;
  };
}
